import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagBN = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 49.996c13.805 0 24.996-11.19 24.996-24.996C49.996 11.195 38.806.004 25 .004 11.195.004.004 11.194.004 25 .004 38.805 11.195 49.996 25 49.996Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#000",
  d: "M3.352 12.503A25.015 25.015 0 0 0 .838 18.58L42.64 42.716a25.021 25.021 0 0 0 4.006-5.217L3.352 12.503Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M37.498 3.353C27.496-2.422 15.164-.497 7.358 7.285l41.804 24.136C51.999 20.77 47.5 9.127 37.498 3.353ZM12.502 46.647c10.002 5.775 22.334 3.85 30.14-3.932L.838 18.579C-1.999 29.23 2.5 40.873 12.502 46.647Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M32.065 22.284a7.064 7.064 0 1 1-13.28-3.36 8.694 8.694 0 1 0 12.43 0c.542.999.85 2.143.85 3.36Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M23.37 14.132h3.261v16.302h-3.26V14.132Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M30.434 17.393H19.566c0 .75.654 1.359 1.404 1.359h-.045c0 .75.608 1.358 1.358 1.358 0 .75.608 1.359 1.359 1.359h2.717c.75 0 1.358-.609 1.358-1.359.75 0 1.359-.608 1.359-1.358h-.046c.75 0 1.404-.608 1.404-1.359ZM17.393 31.522H32.61v3.26H17.393v-3.26Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M28.261 32.609h6.52v3.26h-6.52v-3.26ZM15.22 32.609h6.52v3.26h-6.52v-3.26Z"
}));
FlagBN.displayName = 'FlagBN';
export default withFlagWrapper(FlagBN);
//# sourceMappingURL=index.js.map